import { render } from "./TwoFactorStart.vue?vue&type=template&id=1ef4fec2&scoped=true"
import script from "./TwoFactorStart.vue?vue&type=script&lang=ts"
export * from "./TwoFactorStart.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-1ef4fec2"

export default script